/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../lib/@waca/core-client/js/core-client/ui/core/View'
], (BaseView) => {

	/**
	 * CascadeSetView represents a view can contain filter items in the filter dock
	 */
	class CascadeSetView extends BaseView {

		constructor({ parentCtrl, cascadeSet, filterItems }){
			super();
			this.cascadeSet = cascadeSet;
			this.parentCtrl = parentCtrl;
			this.filterItems = filterItems;

			cascadeSet.on('change:addColumn',  this.parentCtrl.renderFilterItems, this.parentCtrl);
			cascadeSet.on('change:removeColumn', this.parentCtrl.renderFilterItems, this.parentCtrl);
			cascadeSet.on('change:setPosition', this.parentCtrl.renderFilterItems, this.parentCtrl);

		}

		get className() {
			return 'filter-dock-cascade-container';
		}

		addFilterItem(itemToAdd){
			let added = false;
			let columnIds = this.cascadeSet.getColumnIdList();

			if(this.cascadeSet.getDataSourceId() === itemToAdd.getDataSourceId() &&
				columnIds.indexOf(itemToAdd.getColumnId()) !== -1 ){

				this.$el.children().detach();
				columnIds
					.map(_columnId => {
						const filterItem = this._getFilterItem(_columnId, this.cascadeSet.getDataSourceId());
						if(filterItem){
							this.$el.append(filterItem.getItemDOMnode());
							if(_columnId === itemToAdd.getColumnId()){
								added = true;
							}
						}
					});
			}
			return added;
		}

		getDataSourceId(){
			return this.cascadeSet.getDataSourceId();
		}

		getCascadeSet(){
			return this.cascadeSet;
		}

		_getFilterItem(columnId, datasourceId){
			return Object.values(this.filterItems)
				.find(filterItem => filterItem.getDataSourceId() === datasourceId &&
								filterItem.getColumnId() === columnId);
		}

		/**
		* @return {Object} JQuery node
		*/
		getNode(){
			return this.$el;
		}

		remove(){
			super.remove();
			this.cascadeSet.off('change:addColumn',  this.parentCtrl.renderFilterItems, this.parentCtrl);
			this.cascadeSet.off('change:removeColumn', this.parentCtrl.renderFilterItems, this.parentCtrl);
			this.cascadeSet.off('change:setPosition', this.parentCtrl.renderFilterItems, this.parentCtrl);
			this.cascadeSet = null;
			this.parentCtrl = null;
		}
	}

	return CascadeSetView;

});
